import { removeFlash, useFlashes } from '#/zustand-stores/flashesStore';
import {
  useHorizonFlash,
  useHorizonFlashActions,
} from '#/zustand-stores/horizonFlashStore';
import { FlashBar } from '#/components/FlashBar/FlashBar';

export function FlashesContainer() {
  const { horizonFlash } = useHorizonFlash();
  const { clearHorizonFlash } = useHorizonFlashActions();

  const { flashes } = useFlashes();

  if (flashes.length === 0 && !horizonFlash) return null;

  return (
    <div id="flash-message-container">
      {horizonFlash && (
        <FlashBar
          message={horizonFlash.message}
          style={horizonFlash.style}
          onRemove={() => clearHorizonFlash()}
        />
      )}

      {flashes.map((flash) => (
        <FlashBar
          key={flash.id}
          message={flash.data.message}
          style={flash.data.style}
          onRemove={() => removeFlash(flash.id)}
        />
      ))}
    </div>
  );
}
